<template>
  <div
    id="verification"
    class="tw-relative md:tw-w-96 tw-w-11/12 tw-flex tw-flex-col tw-items-center tw-mx-auto tw-pb-8"
  >
    <img
      class="back-btn tw-absolute tw-left-0 tw-cursor-pointer"
      src="@/assets/img/back-button.svg"
      alt="back button"
      @click="goBack"
    />
    <OnboardingHeader
      headerText="Please provide your two-factor authentication code to verify your account"
    />
    <OnboardingSubHeader :subHeaderText="subHeaderText" />
    <VerificationForm @verify="verify" />
    <div class="tw-mt-44"></div>
  </div>
</template>
    
    <script>
import { mapActions } from "vuex";
import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
import VerificationForm from "@/components/onboarding/forms/2FaVerificationForm";
import api from "@/utils/api.js";
import responseHandler from "@/utils/responseHandler.js";
import { getItem, setItem, clearStorage } from "@/utils/storage.js";

export default {
  name: "2Fa",

  components: {
    OnboardingHeader,
    OnboardingSubHeader,
    VerificationForm,
  },

  data() {
    return {
      subHeaderText: "",
      email: "",
    };
  },

  created() {
    this.checkOrgCountry();
  },

  mounted() {
    this.email = getItem("org_details")?.email;
    this.setSubHeader();
    this.showToast({
      description: "Please verify your account",
      display: true,
      type: "info",
    });
  },

  methods: {
    ...mapActions("organisationModule", ["getOrganisationProfile"]),
    ...mapActions("loadingModule", ["verifySuccess", "verifyLoading"]),
    ...mapActions(["showToast"]),

    async verify(code) {
      this.verifyLoading(true);

      try {
        const validateResponse = await api.validate2FaToken({ token: code });
        const { message, status } = validateResponse.data;

        if (status === "success") {
          this.verifySuccess(true);
          this.showToast({
            description:
              message || "Two-factor authentication verified successfully",
            display: true,
            type: "success",
          });

          const profileResponse = await this.getOrganisationProfile();

          setItem("two_fa_verified", true);

          this.$router.push({ name: "OverviewDetails" });
        }
      } catch (error) {
        responseHandler.handleError(error, { skipLogout: true });
      } finally {
        this.verifyLoading(false);
      }
    },

    checkOrgCountry() {
      const orgDetails = getItem("org_details");

      if (!orgDetails?.country) {
        console.warn("Missing country in org_details. Redirecting...");

        this.$router.replace({ name: "CreateAccount" });

        this.showToast({
          description: "Please create an account",
          display: true,
          type: "error",
        });
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    setSubHeader() {
      this.subHeaderText = `Please type in your code so we can verify your account with 2Fa`;
    },
  },
};
</script>
    
    <style lang="scss" scoped>
#verification {
  .back-btn {
    top: -3rem;
  }
}
</style>
    